import * as mobileHelper from "../node_modules/mobile-device-detect/dist/index.js";
import Fingerprint2 from "fingerprintjs2";
export { mobileHelper, Fingerprint2 };

export function isIOS() {
    return (
        ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(
            navigator.platform
        ) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
}

export function isDemo() {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get("demo") !== null;
}

export function isMobile() {
    const searchParams = new URLSearchParams(window.location.search);
    const result = Boolean(
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        ) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
            // force mobile for manager preview
            (isDemo() && searchParams.get("desktop") === null) ||
            searchParams.has("forceDesktop")
    );

    return result;
}

export function isPortrait() {
    const searchParams = new URLSearchParams(window.location.search);
    const result =
        searchParams.has("forceDesktop") ||
        ((!isMobile() ||
            window.orientation === 0 ||
            screen.availHeight > screen.availWidth ||
            (isDemo() && searchParams.get("portrait") !== null)) &&
            !(isDemo() && searchParams.get("landscape") !== null));

    return result;
}

export function getAndroidVersion() {
    const result = navigator.userAgent.match(/Android (\d+(?:\.\d+)*);/);
    if (result && result.length >= 2) {
        return parseFloat(result[1]);
    }

    return -1;
}

export function canNativeShare(): boolean {
    return typeof navigator.share === "function";
}

export async function nativeShare(title: string, text: string, url: string): Promise<void> {
    const shareData = {
        url: url,
        title,
        text
    };

    try {
        await navigator.share(shareData);
    } catch (err) {
        console.error(err);
    }
}
